import { Button } from '@/components/ui/button';
import { AppScreen, IconAction } from '@/components/ui/scene';
import { Text } from '@/components/ui/text';
import { router, Stack } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';
import { ArrowLeftIcon } from 'lucide-react-native';
import * as React from 'react';
import { View } from 'react-native';

export function LegalBrowserScreen({ title, url }: { title: string; url: string }) {
  const [status, setStatus] = React.useState<'opening' | 'ready'>('opening');

  const openLegalPage = React.useCallback(async () => {
    setStatus('opening');
    try {
      await WebBrowser.openBrowserAsync(url, {
        presentationStyle: WebBrowser.WebBrowserPresentationStyle.PAGE_SHEET,
      });
    } finally {
      setStatus('ready');
    }
  }, [url]);

  React.useEffect(() => {
    openLegalPage().catch(() => setStatus('ready'));
  }, [openLegalPage]);

  return (
    <AppScreen>
      <Stack.Screen
        options={{
          title,
          headerShown: false,
        }}
      />
      <View className="flex-row items-center justify-between px-4 pt-4">
        <IconAction icon={ArrowLeftIcon} onPress={() => router.back()} />
        <Text className="text-2xl font-extrabold tracking-tight">{title}</Text>
        <View className="size-11" />
      </View>

      <View className="flex-1 justify-center gap-5 px-6 pb-16">
        <View className="gap-3">
          <Text className="text-4xl font-extrabold tracking-tight">Opening Radious Docs</Text>
          <Text className="leading-6 text-muted-foreground">
            {title} now lives at docs.radious.app so the app, web, and support pages all point to
            one canonical version.
          </Text>
        </View>
        <Button className="rounded-full" onPress={openLegalPage}>
          <Text>{status === 'opening' ? 'Opening...' : `Open ${title}`}</Text>
        </Button>
      </View>
    </AppScreen>
  );
}
